import { call, put, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { expertInputDocuments } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';

// Create actions and a reducer for the expertInput resource
export const [actions, reducer, resourceSagas] = resourceReducer(
  'expert-input-documents'
);

// Create the sagas for this entity
function* readExpertInputDocument() {
  yield takeEvery(actions.indexRequestBegin, function* ({ payload }) {
    const { args } = payload;
    try {
      const result = yield call(expertInputDocuments.get, args);
      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess({ ...normalized, args }));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

export const sagas = [readExpertInputDocument, ...resourceSagas];
